import { useState } from "react";
import { sendNotifications } from "./notifications";

export const useSendNotifications = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const handleSendNotifications = async (usersIds, message) => {
    try {
      setIsLoading(true);
      setError(null);

      const responseData = await sendNotifications(usersIds, message);

      setResponse(responseData);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    response,
    handleSendNotifications,
  };
};
